module.exports = __webpack_public_path__ + "static/media/18ECA20.9d049aff.jpg";